import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

//importing style
// import "antd/dist/antd.css";
import "react-toastify/dist/ReactToastify.css";
import "./sass/main.css";

//importing store
import { store } from "./store/store";
import { Provider } from "react-redux";

const container = document.getElementById("root");
// const root = ReactDOM.createRoot(container);
// root.render(<App />);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  container
);
